import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSubscript16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconSubscript16"
            aria-hidden="true"
            {...props}
        >
            <g fill="none" stroke="currentColor" strokeLinecap="round">
                <path strokeLinejoin="round" d="M9.97 11.711 2.548 4.29m0 7.421L9.971 4.29" />
                <path d="m12.17 9.944 1.336-.318v3.908" />
            </g>
        </svg>
    );
}
export default memo(IconSubscript16);
